import { render, staticRenderFns } from "./QuantityPerUnitChart.vue?vue&type=template&id=64b401ad&scoped=true"
import script from "./QuantityPerUnitChart.vue?vue&type=script&lang=js"
export * from "./QuantityPerUnitChart.vue?vue&type=script&lang=js"
import style0 from "./QuantityPerUnitChart.vue?vue&type=style&index=0&id=64b401ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b401ad",
  null
  
)

export default component.exports